import { render, staticRenderFns } from "./UserChangePasswordContainer.vue?vue&type=template&id=06814cd8&"
import script from "./UserChangePasswordContainer.vue?vue&type=script&lang=ts&"
export * from "./UserChangePasswordContainer.vue?vue&type=script&lang=ts&"
import style0 from "./UserChangePasswordContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports